import { render } from "./CreateFiltersFromExternalResourceModal.vue?vue&type=template&id=54c8f19d"
import script from "./CreateFiltersFromExternalResourceModal.vue?vue&type=script&lang=js"
export * from "./CreateFiltersFromExternalResourceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__